import { createAction } from 'typesafe-actions'
import { Call, Endpoint, Line, Settings, VideoSourceType, HidDevice } from '../model'

export const initApp = createAction('webrtc/INIT_APP')()

export const endpointStatusChanged = createAction('webrtc/ENDPOINT_STATUS_CHANGED')<Endpoint>()
export const connectEndpoint = createAction('webrtc/CONNECT_ENDPOINT', (extension: string, pin: string) => ({ extension, pin }))()
export const connectEndpointGuest = createAction('webrtc/CONNECT_ENDPOINT_GUEST', (guestId: string, guestPasskey: string, displayName: string) => ({ guestId, guestPasskey, displayName }))()
export const disconnectEndpoint = createAction('webrtc/DISCONNECT_ENDPOINT')()
export const configureEndpoint = createAction('webrtc/CONFIG_ENDPOINT')<Settings>()
export const pairHeadset = createAction('webrtc/PAIR_HEADSET')()

export const lineStatusChanged = createAction('webrtc/LINE_STATUS_CHANGED')<Line>()
// export const register = createAction('REGISTER')()
// export const unregister = createAction('UNREGISTER')()

export const configureMediaConstraints = createAction('webrtc/CONFIGURE_MEDIA_CONSTRAINTS')<MediaTrackConstraints>()
export const configureSecondaryRinger = createAction('webrtc/CONFIGURE_SECONDARY_RINGER')<string>()

export const callStatusChanged = createAction('webrtc/CALL_STATUS_CHANGED', (focusCallIndex: number, calls: Call[]) => ({ focusCallIndex, calls }))()
export const dial = createAction('webrtc/DIAL')<string>()
export const hangUp = createAction('webrtc/HANG_UP')()
export const declineBusy = createAction('webrtc/DECLINE_BUSY')()
export const muteMicrophone = createAction('webrtc/MUTE_MICROPHONE', (mute: boolean) => mute)()
export const muteSpeaker = createAction('webrtc/MUTE_SPEAKER', (mute: boolean) => mute)()
export const dtmf = createAction('webrtc/DTMF')<string>()
export const answer = createAction('webrtc/ANSWER')()
export const hold = createAction('webrtc/HOLD')()
export const resume = createAction('webrtc/RESUME')()
export const toggleVideo = createAction('webrtc/TOGGLE_VIDEO', (enable: boolean, videoSource?: VideoSourceType) => ({ enable, videoSource }))()
export const setVideoPan = createAction('webrtc/SET_VIDEO_PAN')<number>()
export const setVideoTilt = createAction('webrtc/SET_VIDEO_TILT')<number>()
export const setVideoZoom = createAction('webrtc/SET_VIDEO_ZOOM')<number>()
export const transfer = createAction('webrtc/TRANSFER')()
export const toogle = createAction('webrtc/TOGGLE')()
export const blindXfer = createAction('webrtc/BLIND_XFER')<string>()
export const getCallStats = createAction('webrtc/CALL_GET_STATS')()
export const queueHold = createAction('webrtc/QUEUE_HOLD')()
export const queueResume = createAction('webrtc/QUEUE_RESUME')()
export const queueHoldFor = createAction('webrtc/QUEUE_HOLD_FOR')<string>()
export const sendToVoicemail = createAction('webrtc/SEND_TO_VOICEMAIL')()

export const startAudioRecording = createAction('webrtc/START_AUDIO_RECORDING')()
export const stopAudioRecording = createAction('webrtc/STOP_AUDIO_RECORDING')()
export const suppressAllRecordings = createAction('webrtc/SUPPRESS_ALL_RECORDINGS')()
export const unsuppressAllRecordings = createAction('webrtc/UNSUPPRESS_ALL_RECORDINGS')()

export const startOnDemandScreenRecording = createAction('webrtc/START_ON_DEMAND_SCREEN_RECORDING', (tag: string, recordAudio: boolean) => ({ tag, recordAudio }))()
export const stopOnDemandScreenRecording = createAction('webrtc/STOP_ON_DEMAND_SCREEN_RECORDING')()

export const setWebHidDeviceList = createAction('SET_WEBHID_DEVICE_LIST')<HidDevice[]>()
export const setSelectedJabraDevice = createAction('SET_SELECTED_JABRA_DEVICE')<{ deviceName: string, deviceId: string } | null>()